import { Component } from '@theme/component';

class CHGreetingCardMessage extends Component {
  requiredRefs = ['message', 'count'];

  connectedCallback() {
    super.connectedCallback();
    this.#updateCount();
  }

  handleInput() {
    this.#updateCount();
  }

  #updateCount() {
    const { message, count } = this.refs;
    const maximum = message.maxLength > 0 ? message.maxLength : 240;
    count.textContent = `${message.value.length} / ${maximum}`;
  }
}

if (!customElements.get('ch-greeting-card-message')) {
  customElements.define('ch-greeting-card-message', CHGreetingCardMessage);
}
